import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\LanguageController::languages
* @see app/Http/Controllers/LanguageController.php
* @route '/api/local/languages'
*/
export const languages = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: languages.url(options),
    method: 'get',
})

languages.definition = {
    methods: ["get","head"],
    url: '/api/local/languages',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LanguageController::languages
* @see app/Http/Controllers/LanguageController.php
* @route '/api/local/languages'
*/
languages.url = (options?: RouteQueryOptions) => {
    return languages.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\LanguageController::languages
* @see app/Http/Controllers/LanguageController.php
* @route '/api/local/languages'
*/
languages.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: languages.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LanguageController::languages
* @see app/Http/Controllers/LanguageController.php
* @route '/api/local/languages'
*/
languages.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: languages.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\LanguageController::userLocal
* @see app/Http/Controllers/LanguageController.php
* @route '/api/local/user-locale'
*/
export const userLocal = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: userLocal.url(options),
    method: 'get',
})

userLocal.definition = {
    methods: ["get","head"],
    url: '/api/local/user-locale',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LanguageController::userLocal
* @see app/Http/Controllers/LanguageController.php
* @route '/api/local/user-locale'
*/
userLocal.url = (options?: RouteQueryOptions) => {
    return userLocal.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\LanguageController::userLocal
* @see app/Http/Controllers/LanguageController.php
* @route '/api/local/user-locale'
*/
userLocal.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: userLocal.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LanguageController::userLocal
* @see app/Http/Controllers/LanguageController.php
* @route '/api/local/user-locale'
*/
userLocal.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: userLocal.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\LanguageController::translations
* @see app/Http/Controllers/LanguageController.php
* @route '/api/local/translations/{local}'
*/
export const translations = (args: { local: string | number } | [local: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: translations.url(args, options),
    method: 'get',
})

translations.definition = {
    methods: ["get","head"],
    url: '/api/local/translations/{local}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LanguageController::translations
* @see app/Http/Controllers/LanguageController.php
* @route '/api/local/translations/{local}'
*/
translations.url = (args: { local: string | number } | [local: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { local: args }
    }

    if (Array.isArray(args)) {
        args = {
            local: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        local: args.local,
    }

    return translations.definition.url
            .replace('{local}', parsedArgs.local.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LanguageController::translations
* @see app/Http/Controllers/LanguageController.php
* @route '/api/local/translations/{local}'
*/
translations.get = (args: { local: string | number } | [local: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: translations.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LanguageController::translations
* @see app/Http/Controllers/LanguageController.php
* @route '/api/local/translations/{local}'
*/
translations.head = (args: { local: string | number } | [local: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: translations.url(args, options),
    method: 'head',
})

const LanguageController = { languages, userLocal, translations }

export default LanguageController